<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col cols="12" sm="10"></v-col>
        <v-col cols="12" sm="2">
          <v-btn class="ml-12" color="primary" dark @click="dialog=true">Create Question</v-btn>
          <v-dialog v-model="dialog" max-width="700px" color="blue">
            <v-card v-if="serveyStatus==true">
              <v-card-title class="secondary">
                <span class="subtitle-2 white--text">Create Question</span>
                <v-spacer></v-spacer>
                <v-icon @click="closeCreate()" class="white--text">mdi-close</v-icon>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12" lg="12" class="pt-7">
                    <v-select
                      :items="surveyTypesList"
                      v-model="surveyType"
                      item-text="source_name"
                      item-value="source_id"
                      label="Survey Source"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="secondary black--text" @click="nextmethod()">Next</v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-if="serveyStatus==false">
              <v-card-title class="secondary">
                <span class="subtitle-2 white--text">Create Question</span>
                <v-spacer></v-spacer>
                <v-icon @click="closeCreate()" class="white--text">mdi-close</v-icon>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12" lg="12" class="pt-7">
                    <v-text-field v-model="questions" :maxlength="max" label="Enter the Question"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="3" class="mt-n8">
                    <v-select
                      :items="items"
                      v-model="questionType"
                      @change="questionMethod()"
                      label="Field Type"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" class="mt-n8" v-if="validationTest==true">
                    <v-text-field
                      type="number"
                      v-model="charactertext"
                      label="Minimum Character"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" class="mt-n8" v-if="validationNumber==true">
                    <v-text-field
                      type="decimal"
                      v-model="characterNumber"
                      label="Minimum Value"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2" class="mt-n7">
                    <v-checkbox v-model="mandatory" label="Mandatory"></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" class="mt-n3">
                    <v-btn
                      class="primary black--text ml-3"
                      depressed
                      small
                      text
                      @click="insertToTable()"
                    >Add</v-btn>
                  </v-col>
                </v-row>
                <v-data-table
                  v-if="showTableStatus==true"
                  :headers="headersQuestion"
                  :items="listQuestionWitnType"
                  dense
                  hide-default-footer
                  class="elevation-1"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
                  </template>
                </v-data-table>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary black--text" text @click="serveyback()">back</v-btn>
                <v-btn
                  class="secondary black--text"
                  :loading="loading2"
                  :disabled="listQuestionWitnType.length == 0"
                  text
                  @click="createQuestionTemplate()"
                >Create</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>

    <template>
      <v-row>
        <v-col cols="12" sm="6">
          <v-card>
            <v-card-title class="subheading font-weight-bold" dense>New Business</v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-item v-if="newBusinessData.length==0">
                <v-list-item-content>No Data Available</v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list dense>
              <v-list-item v-for="item in newBusinessData" :key="item.id">
                <v-list-item-content>{{ item.label }}</v-list-item-content>
                <v-list-item-content>{{ item.typeValue }}</v-list-item-content>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon v-if="item.mandatory==true" class="align-end">check</v-icon>
                    </v-btn>
                  </template>
                  <span>Mandatory</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-btn icon color="secondary">
                        <v-icon @click="deleteBusiness(item)">delete_forever</v-icon>
                      </v-btn>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-btn icon color="secondary">
                        <v-icon @click="editQuestion(item)">mdi-pencil</v-icon>
                      </v-btn>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card>
            <v-card-title class="subheading font-weight-bold" dense>Claim</v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-item v-if="claimdata.length==0">
                <v-list-item-content>No Data Available</v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list dense>
              <v-list-item v-for="item in claimdata" :key="item.id">
                <v-list-item-content>{{ item.label }}</v-list-item-content>
                <v-list-item-content class="align-end">{{ item.typeValue }}</v-list-item-content>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon v-if="item.mandatory==true" class="align-end">check</v-icon>
                    </v-btn>
                  </template>
                  <span>Mandatory</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-btn icon color="secondary">
                        <v-icon
                          :loading="loading"
                          @click="deleteBusiness(item,item.index)"
                        >delete_forever</v-icon>
                      </v-btn>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-btn icon color="secondary">
                        <v-icon @click="editQuestion(item)">mdi-pencil</v-icon>
                      </v-btn>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </v-list-item>
            </v-list>
            <v-dialog v-model="editQuestionStatus" max-width="700px">
              <v-card>
                <v-card-title class="secondary">
                  <span class="subtitle-2 white--text">Edit Question</span>
                  <v-spacer></v-spacer>
                  <v-icon @click="editQuestionStatus=false" class="white--text">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12" lg="12" class="pt-7">
                      <v-text-field
                        v-model="editQuestions"
                        :maxlength="max"
                        label="Enter the Question"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3" class="mt-n8">
                      <v-select
                        :items="items"
                        v-model="editQuestionType"
                        @change="editQuestionMethod()"
                        label="Field Type"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" class="mt-n8" v-if="validationTest==true">
                      <v-text-field
                        type="number"
                        v-model="editCharactertext"
                        label="Minimum Character"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" class="mt-n8" v-if="validationNumber==true">
                      <v-text-field
                        type="decimal"
                        v-model="editCharacterNumber"
                        label="Minimum Value"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2" class="mt-n7">
                      <v-checkbox v-model="editMandatory" label="Mandatory"></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    class="secondary black--text"
                    :loading="loading1"
                    @click="updateQuestnType()"
                    text
                  >Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <v-snackbar
      v-model="alertPositive"
      color="secondary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
    <v-snackbar
      v-model="alertNegetive"
      color="primary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
  </v-app>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      serveyStatus: true,
      dialog: false,
      items: ["Text", "Number", "Checklist"],
      selected: false,
      editQuestionStatus: false,
      loading: false,
      loading1: false,
      loading2: false,
      questions: "",
      max: 80,
      questionType: "",
      editCharacterNumber: "",
      editCharactertext: "",
      editQuestionType: "",
      questionId_update: "",
      questnSurveyType_update: "",
      editQuestions: "",
      editMandatory: false,
      validationTest: false,
      qestnListBySourceTypes: [],
      claimdata: [],
      validationNumber: false,
      charactertext: "50",
      headersQuestion: [
        {
          text: "Question",
          align: "start",
          sortable: false,
          value: "label"
        },
        { text: "Type", value: "type" },

        { text: "Actions", value: "actions", sortable: false }
      ],
      listQuestionWitnType: [],
      mandatory: false,
      newBusinessData: [],
      characterNumber: "10",
      surveyType: "",
      surveyTypesList: [],
      showTableStatus: "",
      surveyTypeCreate: "",
      desserts: [
        {
          name: "how is the exprience?",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: "1%",
          glutenfree: true
        },
        {
          name: "Ice cream sandwich",
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: "1%",
          glutenfree: false
        },
        {
          name: "Eclair",
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: "7%",
          glutenfree: false
        },
        {
          name: "Jelly bean",
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: "0%",
          glutenfree: true
        },
        {
          name: "Lollipop",
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: "2%",
          glutenfree: true
        },
        {
          name: "KitKat",
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: "6%",
          glutenfree: false
        }
      ],
      questionIndexId_update: "",
      updateListQuestnArray: [],
      timeout: 2300,
      alertNegetive: false,
      alertPositive: false,
      text: "",
      headers: [
        {
          text: "Label",
          align: "start",
          sortable: false,
          value: "name"
        },
        { text: "Survey Type", value: "calories" },
        { text: "Maximum value", value: "fat" },

        { text: "Gluten-Free", value: "glutenfree" }
      ]
    };
  },
  created() {
    this.getAllSurveyTypes();
  },
  methods: {
    async updateQuestnType() {
      if (this.editQuestions != "" || this.editQuestions.trim() != "") {
        this.loading1 = true;
        var row = {};
        if (this.editQuestionType == "Text") {
          row = {
            label: this.editQuestions,
            type: "text",
            validations: {
              min_characters: this.editCharactertext
            },
            mandatory: this.editMandatory
          };
        } else if (this.editQuestionType == "Number") {
          row = {
            label: this.editQuestions,
            type: "number",
            validations: {
              min_value: this.editCharacterNumber
            },
            mandatory: this.editMandatory
          };
        } else {
          row = {
            label: this.editQuestions,
            type: "yes_no",
            mandatory: this.editMandatory
          };
        }

        if (this.questionIndexId_update.source_name == "New Business") {
          var index = this.newBusinessData.findIndex(
            obj =>
              obj.id == this.questionIndexId_update.id &&
              obj.question_id == this.questionIndexId_update.question_id
          );

          this.newBusinessData.splice(index, 1, row);
        }
        console.log("newBusinessData2", this.newBusinessData);
        if (this.questionIndexId_update.source_name == "Claim") {
          index = this.claimdata.findIndex(
            obj => obj.id == this.questionIndexId_update.id
          );
          this.claimdata.splice(index, 1, row);
        }
        console.log("claimdata", this.claimdata);
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "QuestionTemplate_UpdateQuestionTemplate",
          input: {
            questionid: this.questionId_update,
            inputquestions:
              this.questionIndexId_update.source_name == "Claim"
                ? JSON.stringify(this.claimdata)
                : JSON.stringify(this.newBusinessData),
            sourcetype: this.getDataBySourceName(this.questnSurveyType_update)
          }
        };
        console.log(input);
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          var updateServior = res.data.data.data;

          if (updateServior == "updated successfully") {
            this.validationTest = false;
            this.validationNumber = false;
            this.creatBlankQestionTemplate();
            this.editQuestionStatus = false;
            this.loading1 = false;
            this.text = "Updated Successfully";
            this.alertPositive = true;
          } else {
            this.validationTest = false;
            this.validationNumber = false;
            this.loading1 = false;
            this.editQuestionStatus = false;
            this.text = "Error";
            this.alertNegetive = true;
          }
        } catch (error) {
          //console.log(error.response);
          return error.response;
        }
      } else {
        this.alertNegetive = true;
        this.text = "Please Enter Question";
      }
    },
    editQuestion(item) {
      console.log(item);
      this.questionIndexId_update = item;
      this.questionId_update = item.question_id;
      this.questnSurveyType_update = item.source_name;
      this.editQuestionStatus = true;

      this.editQuestions = item.label;
      if (item.type == "yes_no") {
        this.editQuestionType = "Checklist";
        this.validationNumber = false;
        this.validationTest = false;
      } else if (item.type == "text") {
        this.editQuestionType = "Text";
        this.validationTest = true;
        this.validationNumber = false;
        var textTrial = item.typeValue.replace("Text(", "");
        this.editCharactertext = textTrial.replace(")", "");
      } else {
        this.editQuestionType = "Number";
        this.validationNumber = true;
        this.validationTest = false;
        var numberTrial = item.typeValue.replace("Number(", "");
        this.editCharacterNumber = numberTrial.replace(")", "");
      }
    },
    getDataBySourceName(SourceTypeName) {
      var surveyname = "";

      this.surveyTypesList.forEach(function(element) {
        if (SourceTypeName == element.source_name) {
          surveyname = element.source_id;
        }
      });

      return surveyname;
    },
    async deleteBusiness(item) {
      this.loading = true;

      var index = 0;
      if (item.source_name == "New Business") {
        index = this.newBusinessData.findIndex(obj => obj.label == item.label);
        this.newBusinessData.splice(index, 1);
      }
      if (item.source_name == "Claim") {
        index = this.claimdata.findIndex(obj => obj.label == item.label);
        this.claimdata.splice(index, 1);
      }

      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "QuestionTemplate_UpdateQuestionTemplate",
        input: {
          questionid: item.question_id,
          inputquestions:
            item.source_name == "Claim"
              ? JSON.stringify(this.claimdata)
              : JSON.stringify(this.newBusinessData),
          sourcetype: this.getDataBySourceName(item.source_name)
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        var surveyTypesDelete = res.data.data.success;

        if (surveyTypesDelete == true) {
          this.text = "Deleted Successfully";
          this.alertPositive = true;
        } else {
          this.text = "Error";
          this.alertNegetive = true;
        }
        this.loading = false;
        this.creatBlankQestionTemplate();
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    serveyback() {
      this.listQuestionWitnType = [];
      this.serveyStatus = true;
      this.questions = "";
      this.questionType = "";
      this.showTableStatus = false;
      this.surveyType = "";
    },
    nextmethod() {
      if (this.surveyType != "") {
        this.serveyStatus = false;
      } else {
        this.alertNegetive = true;
        this.text = "Please Enter Survey Type";
      }
    },
    deleteItem(item) {
      const index = this.listQuestionWitnType.indexOf(item);
      this.listQuestionWitnType.splice(index, 1);
    },
    insertToTable() {
      if (
        this.questions != "" &&
        this.questionType != "" &&
        this.questions.trim() != ""
      ) {
        this.showTableStatus = true;
        var row = {};
        if (this.questionType == "Text") {
          row = {
            label: this.questions,
            type: "text",
            validations: {
              min_characters: this.charactertext
            },
            mandatory: this.mandatory
          };
          this.listQuestionWitnType.push(row);
        } else if (this.questionType == "Number") {
          row = {
            label: this.questions,
            type: "number",
            validations: {
              min_value: this.characterNumber
            },
            mandatory: this.mandatory
          };
          this.listQuestionWitnType.push(row);
        } else {
          row = {
            label: this.questions,
            type: "yes_no",
            mandatory: this.mandatory
          };
          this.listQuestionWitnType.push(row);
        }

        this.validationNumber = false;
        this.validationTest = false;
        this.questions = "";
        this.mandatory = false;
        this.questionType = "";
      } else {
        this.alertNegetive = true;
        this.text = "Please Enter Question and Field Type";
      }
    },
    closeCreate() {
      this.serveyStatus = true;
      this.listQuestionWitnType = [];
      this.validationNumber = false;
      this.validationTest = false;
      this.questionType = "";
      this.surveyType = "";
      this.dialog = false;
    },
    async createQuestionTemplate() {
      console.log(this.listQuestionWitnType);
      this.loading2 = true;
      if (this.listQuestionWitnType.length == 0) {
        this.alertNegetive = true;
        this.text = "Please Enter Question and Field Type";
      } else {
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "QuestionTemplate_createQuestionTemplate",
          input: {
            questiondesc: JSON.stringify(this.listQuestionWitnType),
            questiontype: this.surveyType,
            orgid: this.$store.getters.get_orgId
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          var create = res.data.data;
          console.log(create);
          this.showTableStatus = false;
          this.loading2 = false;
          this.alertPositive = true;
          this.text = "Successfully Created ";
          this.dialog = false;
          this.serveyStatus = true;
          this.listQuestionWitnType = [];

          this.surveyType = "";

          this.creatBlankQestionTemplate();
        } catch (error) {
          //console.log(error.response);
          return error.response;
        }
      }
    },

    async getAllSurveyTypes() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetSource_getAllSourceByOrgID",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.surveyTypesList = [];
        this.surveyTypesList = res.data.data.data;

        this.creatBlankQestionTemplate();
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    questionClose() {
      this.validationNumber = false;
      this.validationTest = false;
      (this.questionType = ""), (this.dialog = false);
    },
    editQuestionMethod() {
      if (this.editQuestionType == "Text") {
        this.validationTest = true;
        this.validationNumber = false;
      } else if (this.editQuestionType == "Number") {
        this.validationNumber = true;
        this.validationTest = false;
      } else {
        this.validationNumber = false;
        this.validationTest = false;
      }
    },
    questionMethod() {
      if (this.questionType == "Text") {
        this.validationTest = true;
        this.validationNumber = false;
      } else if (this.questionType == "Number") {
        this.validationNumber = true;
        this.validationTest = false;
      } else {
        this.validationNumber = false;
        this.validationTest = false;
      }
    },
    getDataBySource(SourceTypeid) {
      var surveyname = "";
      // if (this.surveyTypesList.length == 0) {
      //   await this.getAllSurveyTypes();
      // }

      this.surveyTypesList.forEach(function(element) {
        if (SourceTypeid == element.source_id) {
          surveyname = element.source_name;
        }
      });

      return surveyname;
    },
    getmethodByserveytypes(sourceList) {
      console.log(sourceList);
      var questDescArray = [];
      sourceList.forEach(function(element) {
        element.question_desc = JSON.parse(element.question_desc);
        element.question_desc.forEach(function(ele) {
          ele.source_name = element.source_name;
          ele.question_id = element.question_id;
          questDescArray.push(ele);
        });
      });
      console.log("questDescArray", questDescArray);
      var self = this;
      self.newBusinessData = [];
      self.claimdata = [];
      questDescArray.forEach(function(ele) {
        if (ele.source_name == "New Business") {
          self.newBusinessData.push(ele);
        } else {
          self.claimdata.push(ele);
        }
      });

      this.newBusinessData.forEach(function(element, index) {
        element.id = index;
        if (element.type == "text") {
          element.typeValue =
            "Text" + "(" + element.validations.min_characters + ")";
        }

        if (element.type == "number") {
          element.typeValue =
            "Number" + "(" + element.validations.min_value + ")";
        }
        if (element.type == "yes_no") {
          element.typeValue = "Checklist" + "(" + "YES/N0" + ")";
        }
      });
      console.log("NewBusinessDatappppppppppppp", self.newBusinessData);
      // console.log("NewBusinessDatappppppppppppp", this.newBusinessData);
      this.claimdata.forEach(function(element, index) {
        element.id = index;
        if (element.type == "text") {
          element.typeValue =
            "Text" + "(" + element.validations.min_characters + ")";
        }

        if (element.type == "number") {
          element.typeValue =
            "Number" + "(" + element.validations.min_value + ")";
        }
        if (element.type == "yes_no") {
          element.typeValue = "Checklist" + "(" + "YES/N0" + ")";
        }
      });
      // console.log("claimdata", this.claimdata);
    },

    async creatBlankQestionTemplate() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "QuestionTemplate_getAllQuestionsOfOrg",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.qestnListBySourceTypes = res.data.data.data;
        console.log("qestnListBySourceTypes", this.qestnListBySourceTypes);
        var self = this;
        this.quesstionList = [];
        self.qestnListBySourceTypes.forEach(function(element) {
          element.source_name = self.getDataBySource(element.question_typeid);
          if (element.source_name != "") {
            self.quesstionList.push(element);
          }
        });

        self.getmethodByserveytypes(self.quesstionList);
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    }
  }
};
</script>